import * as Sentry from "@sentry/react";

export default function () {
  if (process.env.RAILS_ENV === "development") {
    return;
  }

  Sentry.init({
    dsn: "https://23c4ef8fc02f1a5d688ea49006892f2b@o4509012338540544.ingest.us.sentry.io/4510144499548160",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.5,
    replaysOnErrorSampleRate: 1.0, // 100% if we have an error
    environment: process.env.RAILS_ENV,
  });
}
